module.exports = __webpack_public_path__ + "static/media/icon_instagram.7637b2f4.svg";